import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { exportExcel, exportPdf } from "../exportTable";

function eligible(t) {
  if (!t || t.closest(".rte-area") || t.closest('[data-testid="signature-preview"]')) return false;
  const ths = t.tHead?.rows?.[0]?.cells?.length || 0;
  const rows = [...t.tBodies].reduce((n, b) => n + b.rows.length, 0);
  return ths >= 2 && rows >= 1;
}

export default function TableExportOverlay() {
  const [target, setTarget] = useState(null);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const hideT = useRef(null);
  const barRef = useRef(null);

  useEffect(() => {
    const place = (t) => {
      if (!t.isConnected) { setTarget(null); return; }
      const r = t.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) { setTarget(null); return; }
      let right = r.right, top = r.top;
      let el = t.parentElement;
      while (el && el !== document.body) {
        const s = getComputedStyle(el);
        if (/(auto|scroll|hidden|clip)/.test(s.overflow + s.overflowX + s.overflowY)) {
          const cr = el.getBoundingClientRect();
          right = Math.min(right, cr.right);
          top = Math.max(top, cr.top);
        }
        el = el.parentElement;
      }
      const hdr = document.querySelector(".inbox-sticky");
      const minTop = hdr ? hdr.getBoundingClientRect().bottom + 6 : 6;
      setPos({ top: Math.max(minTop, top - 30), left: Math.min(window.innerWidth - 170, Math.max(6, right - 164)) });
    };
    const over = (e) => {
      if (barRef.current && barRef.current.contains(e.target)) { clearTimeout(hideT.current); return; }
      const t = e.target.closest?.("table");
      if (t && eligible(t)) {
        clearTimeout(hideT.current);
        setTarget(t);
        place(t);
      } else if (target) {
        clearTimeout(hideT.current);
        hideT.current = setTimeout(() => setTarget(null), 600);
      }
    };
    const onScroll = () => { if (target) place(target); };
    document.addEventListener("mouseover", over);
    window.addEventListener("scroll", onScroll, true);
    return () => { document.removeEventListener("mouseover", over); window.removeEventListener("scroll", onScroll, true); clearTimeout(hideT.current); };
  }, [target]);

  if (!target) return null;
  return createPortal(
    <div ref={barRef} className="tbl-export-bar" style={{ top: pos.top, left: pos.left }} data-testid="table-export-bar">
      <button onClick={() => { try { exportExcel(target); } catch (e) { alert("Errore export: " + e.message); } }} title="Esporta in Excel" data-testid="table-export-excel">📊 Excel</button>
      <button onClick={() => { try { exportPdf(target); } catch (e) { alert("Errore export: " + e.message); } }} title="Esporta in PDF" data-testid="table-export-pdf">📄 PDF</button>
    </div>,
    document.body
  );
}
